import { Link } from "react-router-dom";
import {
  contactInfo,
  footerLinks,
  friendLinks,
  siteName,
  siteTagline,
} from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="border-t border-primary-900/60 bg-primary-950">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-sm border border-accent-500/50 bg-primary-900/60 font-heading text-lg text-accent-300">
                戒
              </span>
              <div>
                <p className="font-heading text-lg text-foreground-50">{siteName}</p>
                <p className="mt-1 font-label text-[9px] uppercase tracking-[0.24em] text-primary-200/70">
                  {siteTagline}
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-[13px] leading-relaxed text-primary-100/70">
              一个专注《色戒》完整版资料整理与深度解读的影迷档案站。我们记录版本差异、叙事细节与幕后故事，让每一次重看都有新的发现。
            </p>
            <ul className="mt-5 space-y-2 text-[13px] text-primary-100/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                {contactInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" />
                {contactInfo.hours}
              </li>
            </ul>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm text-foreground-50">{group.title}</h3>
              <span className="mt-3 block h-px w-8 bg-accent-500/60" />
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="whitespace-nowrap text-[13px] text-primary-100/70 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-primary-900/70 pt-6">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[12px] text-primary-200/60">
              <span className="whitespace-nowrap">友情链接</span>
              {friendLinks.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  className="whitespace-nowrap transition-colors hover:text-accent-300"
                >
                  {item.label}
                </a>
              ))}
            </div>
            <p className="text-[12px] leading-relaxed text-primary-200/60">
              © 2026 {siteName}. 内容均为虚构演示，仅供影视资料交流参考。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}